export const printPluginDownloadUrl =
  "https://hnwms.e-withouse.com/own-wms-api/file/PrinterMonitorSvc.rar";
export const pdfReaderDownloadUrl =
  "https://file.foxitreader.cn/file/Channel/FoxitReader/foxit_FoxitReader_9.2.3.42566.exe";
